import { Instruction } from "./Instructions";

export default Instruction;